import { bl_del_shipment_processing_open_queue_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DeliveryShipmentOpenQueueContainerModel extends BaseContainerModel {
  bl_del_shipment_hdr: bl_del_shipment_processing_open_queue_RowClass = new bl_del_shipment_processing_open_queue_RowClass();
}